<ui-dialog
    [open]="currentlyOpenDialog === 'DETAILS'"
    header="{{
        'time-off-v3.selectedTimeOffTypeAndPolicyWithBalancetimeOffTypenameDetails'
            | translate: { timeOffTypeName: selectedTimeOffTypeAndPolicyWithBalance?.timeOffType.name }
    }}"
    primaryButtonLabel="time-off-v3.done"
    size="small"
    (primaryButtonPressed)="closeDialog(); timeOffTypeDetails.closeExpansionPanel()"
    (closing)="closeDialog(); timeOffTypeDetails.closeExpansionPanel()"
>
    <app-time-off-type-details #timeOffTypeDetails [employee]="employee"></app-time-off-type-details>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'CALCULATE_BALANCE'"
    header="time-off-v3.calculateBalance"
    primaryButtonLabel="time-off-v3.done"
    size="small"
    (primaryButtonPressed)="closeDialog()"
    (closing)="closeDialog()"
>
    <app-calculate-balance-form
        [employeeId]="this.employee.id"
        [timeOffTypes]="timeOffTypes"
        #calculateBalanceForm
    ></app-calculate-balance-form>
</ui-dialog>

<div class="page-container max-width" [class.loading]="isLoading">
    <app-header title="{{ 'time-off-v3.timeOffProfile' | translate }}" [menuService]="tabMenuService">
        <div class="buttons mobile-float">
            <ui-button
                *ngIf="timeOffTypeAndPolicyWithBalances?.length > 0"
                type="primary"
                (click)="createTimeOffRequest()"
                >{{ 'time-off-v3.requestTimeOff' | translate }}</ui-button
            >
        </div>
    </app-header>

    <app-empty-state
        label="{{ 'time-off-v3.noTimeOffTypesCurrentlyAssigned' | translate }}"
        src="/assets/illustrations/empty-box.png"
        *ngIf="!hasTypesAssigned; else hasTypes"
    ></app-empty-state>

    <ng-template #hasTypes>
        <div class="time-off-types">
            <ng-container *ngFor="let timeOffTypeAndPoliciesWithBalance of timeOffTypeAndPolicyWithBalances">
                <app-time-off-policy-card
                    [color]="timeOffTypeAndPoliciesWithBalance.timeOffType.color"
                    [attr.name]="timeOffTypeAndPoliciesWithBalance.timeOffType.name"
                    [timeOffTypeName]="timeOffTypeAndPoliciesWithBalance.timeOffType.name"
                    [isUnlimited]="timeOffTypeAndPoliciesWithBalance.timeOffPolicy.isUnlimited"
                    [unitOfTime]="getUnitOfTime(timeOffTypeAndPoliciesWithBalance.timeOffType)"
                    [amount]="getBalanceAmount(timeOffTypeAndPoliciesWithBalance)"
                    [icon]="timeOffTypeAndPoliciesWithBalance.timeOffType.icon"
                    [balanceDateSetting]="balanceDateSetting"
                    [balanceDateLabel]="timeOffTypeAndPoliciesWithBalance.timeOffBalance.balanceDateLabel"
                >
                    <app-context-item
                        label="{{ 'time-off-v3.calculateBalance' | translate }}"
                        *ngIf="!timeOffTypeAndPoliciesWithBalance.timeOffPolicy.isUnlimited"
                        (click)="
                            viewCalculateBalanceModal(
                                timeOffTypeAndPoliciesWithBalance.timeOffType.id,
                                timeOffTypeAndPoliciesWithBalance.timeOffPolicy.carryoverCap
                            )
                        "
                    ></app-context-item>
                    <ui-button
                        type="outline"
                        class="view-details-button"
                        (click)="viewDetails(timeOffTypeAndPoliciesWithBalance)"
                        >{{ 'time-off-v3.viewDetails' | translate }}</ui-button
                    >
                </app-time-off-policy-card>
            </ng-container>
        </div>

        <ui-card [withMargin]="false" *permission="calendarPermission">
            <app-year-calendar-v3
                #calendar
                title="time-off-v3.yearlyUsage"
                [relatedEntities]="[employee]"
                [eventTypes]="eventTypes"
                [legend]="calendarLegend"
            ></app-year-calendar-v3>
        </ui-card>

        <ui-card [withMargin]="false" [withSpacing]="false">
            <app-table
                [useStickyHeader]="false"
                [showSearch]="false"
                [table]="requestTable"
                [isResponsive]="true"
                [embedded]="true"
                [noPadding]="true"
                title="{{ 'time-off-v3.requests' | translate }}"
            >
                <app-empty-state
                    label="{{ 'time-off-v3.noRequestsFound' | translate }}"
                    src="/assets/illustrations/calendar.png"
                ></app-empty-state>
            </app-table>
        </ui-card>

        <ui-card [withMargin]="false" [withSpacing]="false">
            <app-table
                [useStickyHeader]="false"
                [showSearch]="false"
                [table]="transactionTable"
                [isResponsive]="true"
                [embedded]="true"
                [noPadding]="true"
                title="{{ 'time-off-v3.transactionsLog' | translate }}"
            >
                <app-empty-state
                    label="{{ 'time-off-v3.noTransactionsFound' | translate }}"
                    src="/assets/illustrations/calendar.png"
                ></app-empty-state>
            </app-table>
        </ui-card>
    </ng-template>
</div>
